module.exports = __webpack_public_path__ + "static/media/fantom.59494c04.svg";